import Vue from 'vue'
import axios from 'axios'
import admin from './admin'
import central from './central'
import consultor from './consultor'
import consultoria from './consultoria'
import gestor from './gestor'

const menuByRole = {
  admin,
  consultor,
  gestor,
  central,
  consultoria,
}

const MENU_CACHE_KEY = 'MENU_CACHE'

function getLocalMenu() {
  const user =
    Vue.prototype.$user?.get() ||
    JSON.parse(localStorage.getItem('user') || '{}')
  const role = user.role || 'admin'
  return menuByRole[role] || admin
}

function findInTree(items, targetKey, targetTo) {
  if (!Array.isArray(items)) return null
  for (const item of items) {
    const itemId = item.key || item.id

    if (targetKey && itemId === targetKey) return item
    if (targetTo && item.to === targetTo) return item

    if (item.children && Array.isArray(item.children)) {
      const found = findInTree(item.children, targetKey, targetTo)
      if (found) return found
    }
  }
  return null
}

function applyDbTitles(staticItems, dbItems) {
  if (!Array.isArray(staticItems) || !Array.isArray(dbItems)) return

  staticItems.forEach(staticItem => {
    const dbMatch = findInTree(dbItems, staticItem.key, staticItem.to)

    if (dbMatch && dbMatch.title) {
      Vue.set(staticItem, 'title', dbMatch.title)
    }

    if (staticItem.children && Array.isArray(staticItem.children)) {
      applyDbTitles(staticItem.children, dbItems)
    }
  })
}

export default function getMenu() {
  const localMenu = getLocalMenu()

  // BuscaMENU_CACHE no localStorage
  const cachedMenu = localStorage.getItem(MENU_CACHE_KEY)

  if (cachedMenu) {
    // Se o cache existe, monta imediatamente com ele para máxima performance
    const menuRef = [...localMenu]

    const parsedCache = JSON.parse(cachedMenu)
    if (Array.isArray(parsedCache) && parsedCache.length > 0) {
      applyDbTitles(menuRef, parsedCache)
    }

    // Atualiza em segundo plano o cache do menu, caso tenha mudado no backend
    axios.get('/menu').then(response => {
      const menuDoBanco = response.data?.dados || response.data
      if (menuDoBanco && Array.isArray(menuDoBanco) && menuDoBanco.length > 0) {
        localStorage.setItem(MENU_CACHE_KEY, JSON.stringify(menuDoBanco))
      }
    })

    return menuRef
  }

  //Se NÃO existe cache, cria um array reativo com um estado de carregamento temporário
  const menuRef = [
    {
      key: 'loading-menu',
      icon: 'mdi-loading mdi-spin',
      title: 'Carregando menu...',
      to: '#',
    },
  ]

  //Faz a requisição ao backend
  axios
    .get('/menu')
    .then(response => {
      const menuDoBanco = response.data?.dados || response.data

      if (menuDoBanco && Array.isArray(menuDoBanco) && menuDoBanco.length > 0) {
        // Salva no MENU_CACHE
        localStorage.setItem(MENU_CACHE_KEY, JSON.stringify(menuDoBanco))

        // Prepara o menu local completo aplicando os títulos vindos do banco
        const finalMenu = [...localMenu]
        applyDbTitles(finalMenu, menuDoBanco)

        // Substitui o item de loading pelos dados reais
        menuRef.splice(0, menuRef.length, ...finalMenu)
      } else {
        // Fallback caso venha vazio
        menuRef.splice(0, menuRef.length, ...localMenu)
      }
    })
    .catch(error => {
      // Em caso de erro na API, remove o loading e exibe o menu estático completo
      menuRef.splice(0, menuRef.length, ...localMenu)
      throw error
    })

  return menuRef
}
